import React, { Component } from "react";
import close_btn from '../../../images/close_btn.svg';
import { userService } from "../../../_services/user.service";
import AssignGrandParentRow from "./AssignGrandparentRow";
class AssignAsGrandParent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ChildListData: [],
            save_loader: false,
            submit_msg: '',
            errors: [],
            hasScroll: false,
            isClosing: false
        }
        this.AssignGPUsers = this.AssignGPUsers.bind(this)
        this.tbodyRef = React.createRef();
    }
    componentDidMount() {
        if (this.props?.grandparentsList && this.props?.grandparentsList?.length) {
            const transformedData = this.props.grandparentsList.map(item => ({
                UserName: item.userName,
                UserId: String(item.userId),
                Email: item.email,
                Comm: item.gcComm,
                Enable: item.gpAdded === "Yes"
            }));
            this.setState({ ChildListData: transformedData })
        }
        this.checkForScroll()
    }
    AssignGPUsers() {
        this.setState({ save_loader: true })
        try {
            let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const { repUserName, repId } = this.props
            userService.UpdateGrandParentAdmin(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1], repId, repUserName, this.props.secondLevel, this.state.ChildListData)
                .then(
                    apidata => {
                        this.setState({ save_loader: false })
                        if (apidata.length > 0) {
                            this.setState({ errors: apidata });

                            const allSuccess = apidata.every(item => item.code === "1");

                            if (allSuccess) {
                                setTimeout(() => {
                                    this.props.toggle_gp_popup();
                                }, 3000);
                            }
                        } else {
                            this.setState({ submit_msg: 'Some error occured in submitting' })
                        }
                    }

                );
        }
        catch (error) {
            this.setState({ save_loader: false, submit_msg: 'Some error occured in submitting' })
        }
    }
    handleToggleGP(userName) {
        try {
            const updatedData = this.state.ChildListData.map(item =>
                item.UserName === userName
                    ? { ...item, Enable: !item.Enable }
                    : item
            );
            this.setState({ ChildListData: updatedData });
        } catch (error) {
            console.error("Toggle failed:", error);
        }
    };
    checkForScroll = () => {
        if (this.tbodyRef.current) {
            const hasScroll = this.tbodyRef.current.scrollHeight > this.tbodyRef.current.clientHeight;
            if (this.state.hasScroll !== hasScroll) {
                this.setState({ hasScroll });
            }
        }
    }
    closeModal = () => {
        this.setState({ isClosing: true });
        setTimeout(() => {
            this.props.toggle_gp_popup()
        }, 300);
    }
    render() {
        let { grandparentsList, secondLevel, repUserName } = this.props;

        // Dynamic text based on enable/disable
        const popupTitle = secondLevel
            ? "Enable Second Level Commission"
            : "Disable Second Level Commission";

        const popupSubtext = secondLevel
            ? `The users below will be added as grandchildren to ${repUserName}. 
           You can choose to include or exclude them during this assignment. 
           Going forward all second level signups of ${repUserName} will be grandchildren.`
            : `The users below are existing grandchildren of ${repUserName}. 
           You can choose to keep or remove them during this assignment. 
           Going forward ${repUserName} will not be assigned new grandchildren.`;

        const allowColumnHeader = secondLevel
            ? "Make Grandchild"
            : "Keep Grandchild";

        return (
            <div className={`add_url_pop proceedgp_pop gpEditpopup ${this.state.isClosing ? 'close' : 'open'}`}>
                <div>
                    <div className="header">
                        {popupTitle}
                        <div className="close" onClick={this.closeModal}>
                            <img src={close_btn} alt="" />
                        </div>
                    </div>

                    <div className="body">
                        <div className="overidebox">
                            <div className="override_body">
                                <p style={{ marginBottom: '10px' }}>{popupSubtext}</p>
                                {grandparentsList && grandparentsList.length ? (
                                    <div className="over_ride_table">
                                        <div className="theader">
                                            <div>UserName</div>
                                            <div>FullName</div>
                                            <div>Email</div>
                                            <div>($)Comm.</div>
                                            <div>{allowColumnHeader}</div>
                                        </div>
                                        <div
                                            className={`tbody_parent ${this.state.hasScroll ? "has-scroll" : ""}`}
                                            ref={this.tbodyRef}
                                        >
                                            {grandparentsList.map((row, index) => (
                                                <div className="table_body gplist" key={index}>
                                                    <AssignGrandParentRow
                                                        gpData={row}
                                                        handleToggleGP={this.handleToggleGP.bind(this)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {this.state.errors && this.state.errors.length ? <br /> : null}
                            {this.state.errors && this.state.errors.length > 0
                                ? this.state.errors.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <span className={item.code === '-1' ? "error" : "success"}>{item.message}</span>
                                    </React.Fragment>
                                ))
                                : null}
                        </div>
                    </div>

                    <div className="footer">
                        <div
                            className={this.state.save_loader ? "yes_btn loader" : "yes_btn"}
                            onClick={this.AssignGPUsers}
                        >
                            Proceed
                        </div>
                        <div className="no_btn" onClick={this.closeModal}>Cancel</div>
                        {/*{this.state.submit_msg?.length ? (*/}
                        {/*    <div className="error_submit_msg">{this.state.submit_msg}</div>*/}
                        {/*) : null}*/}
                    </div>
                </div>
            </div>
        );
    }

}
export default AssignAsGrandParent;
